// tell TS “trust me, this exists at runtime”
declare const CompressionStream: any;

/**
 * Gzip-compress a UTF-8 string into a Blob (application/gzip)
 */
export async function gzipBlob(input: string): Promise<Blob> {
  // 1) turn the string into a byte stream
  const encoder = new TextEncoder();
  const sourceStream = new ReadableStream<Uint8Array>({
    start(ctrl) {
      ctrl.enqueue(encoder.encode(input));
      ctrl.close();
    },
  });

  // 2) pass it through CompressionStream('gzip')
  const cs = new CompressionStream('gzip');
  const compressedStream = sourceStream.pipeThrough(cs);

  // 3) collect the result into a Blob
  return await new Response(compressedStream).blob();
}
